module.exports = __webpack_public_path__ + "build/desktop/a/img/air.1b7a36a0ad1459bb5e116394f48ca5e8.png";